import React from 'react';

import './TeamMemberCard.scss';

const TeamMemberCard = props => {
    

    return (
        <div className={props.className || 'presentation-card'}>
                {/* Here we render the image from the JSON... or props? */}
            {props.isYou ? 
            <img className='team-member-icon you' src='media/img/icons/user-shape.svg' alt='' />
            : 
            <img className='team-member-icon' src={props.teamMember.icon} alt='' />}
            <div className='team-member-titles'>
                <p className={props.name || 'card-name'}>
                    {/* First Name, Last Name */}
                    {!props.isYou &&`${props.teamMember.first} ${props.teamMember.last}`}
                    {props.isYou && `You`}
                </p>
                {/* Title */}
                <div className={'card-subtitles'}>
                    <p className={'card-title'}>
                        {props.title || props.teamMember.title},
                    </p>
                    <p className={`card-team`}>
                        {props.teamName || props.teamMember.teamName}
                    </p>
                </div>
            </div>
        </div>
        
    )
}

export default TeamMemberCard;